export const getNodeTypeLabel = (type) => {
  return String(type)
    .replace('loopBreak', 'Loop Break')
    .replace('loopContinue', 'Loop Continue')
    .replace('loop', 'Loop')
    .replace('stripInteractivity', 'Strip Interactivity')
    .replace('repeatAutoFitInteractivity', 'Rep.AutoFit Interactivity')
    .replace('projectUI', 'Project UI')
    .replace('flowFinish', 'Finish Flow')
    .replace('VarInteractivity', 'Variables Interactivity')
    .replace('pwaClearSfCache', 'PWA Clear SF Cache')
    .replace('pwaUpdateSfCache', 'PWA Update SF Cache')
    .replace('surveySubmit', 'Survey Submit')
    .replace('condition', 'Condition')
    .replace('sfAction', 'Salesforce Action')
    .replace('affectElements', 'Affected Elements')
    .replace('uac', 'User Access')
    .replace('WorkFlow', 'Flow')
    .replace('executeJS', 'Execute JS')
    .replace('postMessage', 'Post message')
    .replace('redirect', 'Redirect / Go to Page')
    .replace('msgDlgtoast', 'Show Toast')
    .replace('msgDlgconfirm', 'Confirmation message')
    .replace('msgDlgslack', 'Slack message')
    .replace('msgDlg', 'Show message')
    .replace('SetLanguage', 'Set Language')
    .replace('DrawerUI', 'Drawer/Modal')
    .replace('WFExportDownload', 'Export and Download')
    .replace('sendEmail', 'Send Email')
    .replace('paymentIntegration', 'Payment')
    .replace('docGen', 'Document Generation')
    .replace('geoLoc', 'Geolocation Interactivity')
    .replace('mapInteractivity', 'Map Interactivity')
    .replace('barcodeInteractivity', 'Barcode Interactivity')
    .replace('repeatInteractivity', 'Repeat Interactivity')
    .replace('tabInteractivity', 'Tab Interactivity')
    .replace('timerInteractivity', 'Timer Interactivity')
    .replace('cartInteractivity', 'Cart Interactivity')
    .replace('chartInteractivity', 'Chart Interactivity')
    .replace('continualFormInteractivity', 'Continual Form Interactivity')
    .replace('carouselInteractivity', 'Carousel Interactivity')
    .replace('accordionInteractivity', 'Accordion Interactivity')
    .replace('multiStepInteractivity', 'Multi Step Interactivity')
    .replace('stepInteractivity', 'Stepper Interactivity')
    .replace('formInteractivity', 'Form Interactivity')
    .replace('TabInter', 'Table Interactivity')
    .replace('validate', 'Validate fields')
    .replace('libFlow', 'Library Action Flow')
    .replace('QCounterInteractivity', 'Quantity Counter Interactivity')
}
